import { TBulkAnalyzerFilesState } from "./bulkAnalyzerFiles.types";
import { PageSizeOptions } from "../../constants/productUploads";

export const initialState: TBulkAnalyzerFilesState = {
  files: [],
  isLoading: false,
  total: 0,
  // isPolling: false,
  stats: {
    isLoading: false,
    filesScanned: 0,
    filesUploaded: 0,
    membership: "",
  },
  paginationModel: {
    page: 0,
    pageSize: PageSizeOptions[1], // 20
  },
};
